/**
 * Category Model
 * Data transformation helpers for category API communication
 */

export function mapCategoryFromApi(item = {}) {
  return {
    id: item.id || null,
    name: item.name || '',
    description: item.description || '',
    itemType: item.itemType || 'Mercadoria',
    imageKey: item.imageKey || null,
    createdAt: item.createdAt || null,
    updatedAt: item.updatedAt || null,
  };
}

export function buildCategoryPayload(data) {
  return {
    name: data.name || '',
    description: data.description || '',
    itemType: data.itemType || 'Mercadoria',
    imageFile: data.imageFile || null,
  };
}

export default { mapCategoryFromApi, buildCategoryPayload };
